// extracted by mini-css-extract-plugin
module.exports = {"TeamPage":"TeamPage_TeamPage__3uz1a","TeamPageContainer":"TeamPage_TeamPageContainer__1z4Ju"};